export const validation = {
  selectTagType: 'Please select tag type',
  enterTagName: 'Please enter tag name',
};
